"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Http = void 0;
const query_string_1 = __importDefault(require("query-string"));
const constants_1 = require("./constants");
exports.Http = new (class {
    constructor() {
        Object.defineProperty(this, "Method", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: constants_1.HttpMethod
        });
        Object.defineProperty(this, "HeaderName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: constants_1.HttpHeaderName
        });
        Object.defineProperty(this, "HeaderContentType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: constants_1.HttpHeaderContentType
        });
    }
    stringifyParameters(parameters) {
        return query_string_1.default.stringify(parameters);
    }
    parseParameters(target) {
        return (query_string_1.default.parse(target) || {});
    }
    parseUrlParameters(url) {
        return (query_string_1.default.parseUrl(url).query || {});
    }
    postForm(url, body) {
        return fetch(url, {
            method: this.Method.POST,
            headers: {
                [this.HeaderName.CONTENT_TYPE]: this.HeaderContentType.FORM,
            },
            body: this.stringifyParameters(body),
        })
            .then(this.toSuccess.bind(this))
            .then(this.toJson.bind(this));
    }
    postJson(url, body, extraHeaders) {
        return fetch(url, {
            method: this.Method.POST,
            headers: {
                ...extraHeaders,
                [this.HeaderName.CONTENT_TYPE]: this.HeaderContentType.JSON,
            },
            body: JSON.stringify(body),
        })
            .then(this.toSuccess.bind(this))
            .then(this.toJson.bind(this));
    }
    async get(url, headers) {
        const response = await fetch(url, {
            method: this.Method.GET,
            headers,
        });
        if (!response.ok) {
            throw new Error(`${response.status} ${response.statusText}`);
        }
        return (await response.json());
    }
    toSuccess(response) {
        if (response.ok)
            return response;
        throw new Error(`${response.status} ${response.statusText}`);
    }
    toJson(response) {
        return response.json();
    }
})();
